import { DataSource } from "@/services/state/administration/administration-interface";
import { fetchDataSources } from "../../services/state/administration/administration-async-calls";
import {
  fetchRecordTypesById,
  fetchTableFields,
  fetchTables,
} from "../../services/state/record-types/recordTypes-async-calls";
import { AppDispatch, RootState } from "@/services/state/store";
import {
  Box,
  Center,
  Checkbox,
  Icon,
  IconButton,
  Input,
  useDisclosure,
  VStack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Field } from "@/services/state/record-types/recordTypes-interface";
import { setSelectedHttpIntegrationIo } from "@/services/state/http-integration/httpIntegration";
import { CiCircleChevUp, CiCircleChevDown } from "react-icons/ci";
import { FaMinus } from "react-icons/fa6";
import {
  fetchCustomDataTypesByApplication,
  fetchDataTypes,
} from "../../services/state/custom-data-types/customDataTypes-async-calls";
import { DropDown, Option } from "../../components/Select/DropDown";
import { getAxiosClient } from "../../services/HttpsService";
import { displayName } from "react-quill";

export const useRecordType = () => {
  const { rtId } = useParams();
  const toast = useToast();
  const dispatch: AppDispatch = useDispatch();

  const [selectedDataSource, setSelectedDataSource] = useState<DataSource>();
  const [recordName, setRecordName] = useState("");
  const [tableName, setTableName] = useState("");
  const [fields, setFields] = useState<Field[]>([]);
  const [tableData, setTableData] = useState<
    {
      sno: number;
      name: string;
      displayName: string;
      description: string;
      type: string | undefined;
      other: string | undefined;
      isMultiple: boolean;
      Type: string;
      Null: string;
      Key: string;
      Default: string;
      Extra: string;
    }[]
  >([]);

  const selectedRecordType = useSelector(
    (state: RootState) => state.recordTypes.selectedRecordType
  );

  const selectedDataSourceInitial = useSelector(
    (state: RootState) => state.recordTypes.selectedDataSource
  );

  const selectedFields = useSelector(
    (state: RootState) => state.recordTypes.selectedFields
  );

  const dataSources = useSelector(
    (state: RootState) => state.administration.dataSources
  );

  const dataTypes = useSelector(
    (state: RootState) => state.customDataTypes.dataTypes
  );

  const cdt = useSelector(
    (state: RootState) => state.customDataTypes.customDataTypes
  );

  const selectedTables = useSelector(
    (state: RootState) => state.recordTypes.selectedTables
  );

  const selectedTableFields = useSelector(
    (state: RootState) => state.recordTypes.selectedTableFields
  );

  const dataTypeOptions = dataTypes.map((type, index) => ({
    id: type.dataTypCd,
    name: type.dataTypNm,
    component: <Text key={index}>{type.dataTypNm}</Text>,
  }));

  const cdtOptions = cdt.map((it) => ({
    id: it.uuid,
    name: it.dataTypeName,
    component: <Text>{it.dataTypeName}</Text>,
  }));

  useEffect(() => {
    dispatch(fetchRecordTypesById(rtId as string));
    dispatch(fetchDataSources());
    dispatch(fetchDataTypes());
  }, [rtId]);

  useEffect(() => {
    if (
      selectedRecordType &&
      dataSources !== undefined &&
      selectedFields !== undefined
    ) {
      setSelectedDataSource(
        dataSources.find(
          (ds) => ds.uuid === selectedDataSourceInitial?.dataSourceUuid
        )
      );
      setRecordName(selectedRecordType.recordName);
      setTableName(selectedDataSourceInitial?.tableName || "");
      setFields(selectedFields);
    }
  }, [
    selectedDataSourceInitial,
    dataSources,
    selectedRecordType,
    selectedFields,
  ]);

  useEffect(() => {
    if (selectedTableFields && selectedTableFields.length !== 0) {
      setTableData(
        selectedTableFields?.map((it, index) => {
          const field = fields.find((it1) => it1.fieldName === it.Field);
          return {
            sno: index + 1,
            name: it.Field,
            displayName: field?.fieldDisplayName || "",
            description: field?.fieldDescription || "",
            type: field?.fieldType,
            other: undefined,
            isMultiple: field?.isMultiple || false,
            Type: it.Type,
            Null: it.Null,
            Key: it.Key,
            Default: it.Default,
            Extra: it.Extra,
          };
        })
      );
    }
  }, [selectedTableFields]);

  useEffect(() => {
    if (selectedRecordType)
      dispatch(fetchCustomDataTypesByApplication(selectedRecordType?.appUuid));
  }, [selectedDataSourceInitial]);

  useEffect(() => {
    if (selectedDataSource) dispatch(fetchTables(selectedDataSource.uuid));
  }, [selectedDataSource]);

  useEffect(() => {
    if (tableName && selectedDataSource)
      dispatch(
        fetchTableFields({
          uuid: selectedDataSource.uuid,
          table: tableName,
        })
      );
  }, [tableName, selectedDataSource]);

  const { isOpen: isEditing, onToggle: onEditToggle } = useDisclosure();

  const isEdited = isEditing;

  const columns = [
    {
      Header: "S.no",
      accessor: "sno",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Display Name",
      accessor: "displayName",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Is Multiple",
      accessor: "isMultiple",
    },
    {
      Header: "",
      accessor: "order",
    },
    {
      Header: "",
      accessor: "action",
    },
  ];

  const fieldsData = fields
    ? fields.map((field, index) => ({
        sno: index + 1,
        name: (
          <Input
            key={index}
            value={field.fieldName}
            onChange={(e) => {
              const params = [...fields];
              params[index] = {
                ...params[index],
                fieldName: e.target.value,
              };
              setFields(params);
            }}
            width="10vw"
            readOnly={!isEditing}
          />
        ),
        displayName: (
          <Input
            key={index}
            value={field.fieldDisplayName}
            onChange={(e) => {
              const params = [...fields];
              params[index] = {
                ...params[index],
                fieldDisplayName: e.target.value,
              };
              setFields(params);
            }}
            width="10vw"
            readOnly={!isEditing}
          />
        ),
        description: (
          <Input
            key={index}
            value={field.fieldDescription}
            onChange={(e) => {
              const params = [...fields];
              params[index] = {
                ...params[index],
                fieldDescription: e.target.value,
              };
              setFields(params);
            }}
            width="10vw"
            readOnly={!isEditing}
          />
        ),
        type: (
          <Box key={index} width="10vw">
            <VStack>
              <DropDown
                selected={dataTypeOptions.find(
                  (type) => type.id === field.fieldType
                )}
                title={<Text></Text>}
                options={dataTypeOptions}
                onOptionChange={function (
                  selectedOptions: Option | Option[]
                ): void {
                  if (!Array.isArray(selectedOptions)) {
                    const params = [...fields];
                    params[index] = {
                      ...params[index],
                      fieldType: selectedOptions.id,
                    };
                    setFields(params);
                  }
                }}
                disabled={!isEditing}
              />
              {field.fieldType === "ANY" && (
                <DropDown
                  selected={cdtOptions.find((cdt) => cdt.id === field.other)}
                  title={<Text></Text>}
                  options={cdtOptions}
                  onOptionChange={function (
                    selectedOptions: Option | Option[]
                  ): void {
                    if (!Array.isArray(selectedOptions)) {
                      const params = [...fields];
                      params[index] = {
                        ...params[index],
                        other: selectedOptions.id,
                      };
                      setFields(params);
                    }
                  }}
                  disabled={!isEditing}
                />
              )}
            </VStack>
          </Box>
        ),
        isMultiple: (
          <Center>
            <Checkbox
              defaultChecked
              variant="solid"
              colorScheme="brand"
              onChange={(e) => {
                const params = [...fields];
                params[index] = {
                  ...params[index],
                  isMultiple: e.target.checked,
                };
                setFields(params);
              }}
              isChecked={field.isMultiple}
              isReadOnly={!isEditing}
            />
          </Center>
        ),
        order: (
          <Center key={index}>
            <IconButton
              as={CiCircleChevUp as React.ElementType}
              boxSize="24px"
              aria-label="Move Up"
              onClick={() => {
                if (index > 0) {
                  const params = [...fields];
                  [params[index], params[index - 1]] = [
                    params[index - 1],
                    params[index],
                  ]; // Swap with previous
                  setFields(params);
                }
              }}
              variant="unstyled"
              isDisabled={!isEditing || index === 0}
            />
            <IconButton
              as={CiCircleChevDown as React.ElementType}
              boxSize="24px"
              aria-label="Move Down"
              onClick={() => {
                if (index < fields.length - 1) {
                  const params = [...fields];
                  [params[index], params[index + 1]] = [
                    params[index + 1],
                    params[index],
                  ]; // Swap with next
                  setFields(params);
                }
              }}
              variant="unstyled"
              isDisabled={!isEditing || index === fields.length - 1} // Disable for the last item
            />
          </Center>
        ),
        actions: isEditing ? (
          <Center key={index}>
            <Icon
              as={FaMinus as React.ElementType}
              color="red.500"
              cursor="pointer"
              onClick={() => {
                const params = [...fields];
                params.splice(index, 1);
                setFields(params);
              }}
            />
          </Center>
        ) : null,
      }))
    : [];

  const columnData = fieldsData;

  const tableFieldsColumns = [
    {
      Header: "S.no",
      accessor: "sno",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Display Name",
      accessor: "displayName",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Type",
      accessor: "type",
    },
    {
      Header: "Is Multiple",
      accessor: "isMultiple",
    },
    {
      Header: "Field Type",
      accessor: "Type",
    },
    {
      Header: "Null",
      accessor: "Null",
    },
    {
      Header: "Key",
      accessor: "Key",
    },
    {
      Header: "Default",
      accessor: "Default",
    },
    {
      Header: "Extra",
      accessor: "Extra",
    },
  ];

  const tableFieldsColumnsData = tableData.map((it, index) => ({
    sno: it.sno,
    name: it.name,
    displayName: (
      <Input
        key={index}
        value={it.displayName}
        onChange={(e) => {
          const params = [...tableData];
          params[index] = {
            ...params[index],
            displayName: e.target.value,
          };
          setTableData(params);
        }}
        width="10vw"
        readOnly={!isEditing}
      />
    ),
    description: (
      <Input
        key={index}
        value={it.description}
        onChange={(e) => {
          const params = [...tableData];
          params[index] = {
            ...params[index],
            description: e.target.value,
          };
          setTableData(params);
        }}
        width="10vw"
        readOnly={!isEditing}
      />
    ),
    type: (
      <Box key={index} width="10vw">
        <VStack>
          <DropDown
            selected={dataTypeOptions.find((type) => type.id === it.type)}
            title={<Text></Text>}
            options={dataTypeOptions}
            onOptionChange={function (
              selectedOptions: Option | Option[]
            ): void {
              if (!Array.isArray(selectedOptions)) {
                const params = [...tableData];
                params[index] = {
                  ...params[index],
                  type: selectedOptions.id,
                };
                setTableData(params);
              }
            }}
            disabled={!isEditing}
          />
          {it.type === "ANY" && (
            <DropDown
              selected={cdtOptions.find((cdt) => cdt.id === it?.other)}
              title={<Text></Text>}
              options={cdtOptions}
              onOptionChange={function (
                selectedOptions: Option | Option[]
              ): void {
                if (!Array.isArray(selectedOptions)) {
                  const params = [...tableData];
                  params[index] = {
                    ...params[index],
                    other: selectedOptions.id,
                  };
                  setTableData(params);
                }
              }}
              disabled={!isEditing}
            />
          )}
        </VStack>
      </Box>
    ),
    isMultiple: (
      <Center>
        <Checkbox
          defaultChecked
          variant="solid"
          colorScheme="brand"
          onChange={(e) => {
            const params = [...tableData];
            params[index] = {
              ...params[index],
              isMultiple: e.target.checked,
            };
            setTableData(params);
          }}
          isChecked={it.isMultiple}
          isReadOnly={!isEditing}
        />
      </Center>
    ),
    Type: it.Type,
    Null: it.Null,
    Key: it.Key,
    Default: it.Default,
    Extra: it.Extra,
  }));

  const onAddField = () => {
    const params: Field[] = [
      {
        id: 0,
        recordUuid: "",
        fieldName: "",
        fieldType: "",
        other: "",
        isMultiple: false,
        fieldDisplayName: "",
        fieldDescription: "",
        isActive: "",
        createdBy: "",
        createdOn: "",
        updatedBy: "",
        updatedOn: "",
      },
      ...fields,
    ];
    setFields(params);
  };

  const onSave = async () => {
    if (selectedDataSource === undefined) {
      toast({
        title: "Error",
        description: "Please select a data source.",
        status: "error",
        position: "top",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (tableName === "") {
      toast({
        title: "Error",
        description: "Please select a table.",
        status: "error",
        position: "top",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const data = {
      uuid: rtId,
      name: recordName,
      dataSourceUuid: selectedDataSource.uuid,
      table: tableName,
      fields: tableData.map((it) => ({
        name: it.name,
        displayName: it.displayName,
        description: it.description,
        type: it.type,
        other: it.other,
      })),
    };

    const response = await getAxiosClient().post(
      "/api/eza_app_record_type/update-record-type",
      data
    );

    dispatch(fetchRecordTypesById(rtId as string));

    if (isEditing) onEditToggle();
  };

  return {
    selectedRecordType,
    isEditing,
    onEditToggle,
    isEdited,
    onSave,
    dataSources,
    selectedDataSource,
    setSelectedDataSource,
    recordName,
    setRecordName,
    tableName,
    setTableName,
    columns,
    columnData,
    onAddField,
    selectedTables,
    tableFieldsColumns,
    tableFieldsColumnsData,
  };
};
